import { useState, useCallback } from 'react';

import { useHttpClient } from './http-hook';

export const useCategory = () => {
  const [categories, setCategories] = useState([]);
  const { sendRequest } = useHttpClient();

  const fetchAllCategories = useCallback(async () => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/category/client`
      );

      setCategories(responseData.data.data);
    } catch (err) {}
  }, [sendRequest]);

  return { categories, fetchAllCategories };
};
